import { Search, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { ComparisonStatusFilter } from "../filter";

const STATUS_OPTIONS: { value: ComparisonStatusFilter; label: string }[] = [
  { value: "ALL", label: "Todos os status" },
  { value: "SYNCED", label: "Sincronizadas" },
  { value: "DIVERGENT", label: "Divergentes" },
  { value: "NOT_FOUND_IN_STORE", label: "Não encontradas" },
  { value: "UNREACHABLE", label: "Inacessíveis" },
];

interface ComparisonTableToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: ComparisonStatusFilter;
  onStatusChange: (value: ComparisonStatusFilter) => void;
  filteredCount: number;
  totalCount: number;
}

export function ComparisonTableToolbar({
  search,
  onSearchChange,
  status,
  onStatusChange,
  filteredCount,
  totalCount,
}: ComparisonTableToolbarProps) {
  const hasFilters = search.trim() !== "" || status !== "ALL";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative w-full sm:max-w-xs">
        <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por código ou nome da loja…"
          className="pl-8"
        />
      </div>

      <Select
        value={status}
        onValueChange={(value) =>
          onStatusChange(value as ComparisonStatusFilter)
        }
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          {STATUS_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {hasFilters && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            onSearchChange("");
            onStatusChange("ALL");
          }}
        >
          <X className="mr-1 h-3 w-3" />
          Limpar
        </Button>
      )}

      <span className="ml-auto text-sm text-muted-foreground">
        {hasFilters
          ? `${filteredCount} de ${totalCount} loja(s)`
          : `${totalCount} loja(s)`}
      </span>
    </div>
  );
}
